import LogoEN from "@/assets/images/logo-en.svg";
import LogoNL from "@/assets/images/logo-nl.svg";
import { useLocale } from "@/lib/i18n";

const Logo = () => {
  const locale = useLocale();

  if (locale === "en") return <LogoEN />;

  return <LogoNL />;
};

export default Logo;
